import { render, staticRenderFns } from "./AuditRecordTableCpt.vue?vue&type=template&id=5f106230&scoped=true&"
import script from "./AuditRecordTableCpt.vue?vue&type=script&lang=ts&"
export * from "./AuditRecordTableCpt.vue?vue&type=script&lang=ts&"
import style0 from "./AuditRecordTableCpt.vue?vue&type=style&index=0&id=5f106230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f106230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCheckbox,VCol,VContainer,VPagination,VRow,VSimpleTable,VSkeletonLoader})
